export const PAGINATION_FLIGHT_SERVICE = {
  PAGE_SIZE: 100,
  PAGE_FIRST: 0,
};
